import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import { LoadJobsiteExperienceComplete, LS_LOAD_EXPERIENCE_SUCCESS } from '../actions/jobsite-actions/jobsite.actions';
import { getSelectedExperience, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { IProductExperienceRequest } from '../models/order-management/product.model';
import { ProductExperienceLoadAction } from '../actions/products-actions/products.actions';
import { getStateForLoadProductsConfig } from '../selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class JobsiteLoadExperienceCompleteEffects implements IEffect {
  /**
   * Monitors the actions$ Actions stream (it's a sub-type of Observable) for
   * LS_LOAD_EXPERIENCE_COMPLETE events; then attempts to get a jobsite's experience as
   * an ExperiencesResponse object from the injected ExperiencesService; and finally
   * call another action to evaluate request experience api or online experience api.
   */

  JobsiteLoadExperienceComplete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_LOAD_EXPERIENCE_SUCCESS),
      withLatestFrom(this.store.select(getStateForLoadProductsConfig), this.store.select(getSelectedExperience)),
      filter(([action, jobsiteState, experienceState]: [LoadJobsiteExperienceComplete, any, any]) => {
        return _safe(
          () =>
            !jobsiteState.previousFormState[0].locationConfig.jobsite.selected ||
            jobsiteState.previousFormState[0].locationConfig.jobsite.selected.jobsiteId !==
              jobsiteState.jobsite.selected.jobsiteId,
          true,
        );
      }),
      map(([action, jobsiteState, experienceState]: [LoadJobsiteExperienceComplete, any, any]) => {
        const isOnline = _safe(() => experienceState.experience.experiences[0].isOnline === 1);
        const productExperienceRequest: IProductExperienceRequest = {
          shipmentLocationId: jobsiteState.jobsite.selected.jobsiteId,
          productLineId: jobsiteState.businessLineState.businessLine.selected.productTypeId,
          shippingConditionId: jobsiteState.businessLineState.shippingCondition.selected.shippingConditionId,
          productTypeId: jobsiteState.businessLineState.businessLine.selected.productTypeId,
          jobsiteId: jobsiteState.jobsite.selected.jobsiteId,
          isOnline: isOnline,
          salesDocumentTypeId: action.payload.salesDocumentTypeId,
        };
        return new ProductExperienceLoadAction(productExperienceRequest);
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
  ) {}
}
